import css from "./index.css";
import ClassWatcher from "./classWatcher"
  
  let scriptSrc = document.currentScript ? document.currentScript.src : nullscriptSrc = document.currentScript ? document.currentScript.src : null
  let kaiEngineNames;

  let engagementChat;

  let isWebviewReady = false
  let showWebviewOnceReady = false
  let engagementStarted = false
  let engagementStartedTimerHolder = false

  let messagesToRenderWhenReady = []

  let messagesHistory = []

  let body = document.getElementsByTagName('body')[0];

  let gliaAPI = false
  
  let showWebviewWidget = () => {
    if (typeof $store !== 'undefined' &&  $store !== undefined && $store.state !== undefined) {
      $store.state.showWebviewWidget = true;
      if ($store.state.startSession && $store.state.webviewReady && $store.state.kaiSessionId === '') {
        kserver.CoreAPI.startSession()
      }
    } else {
      showWebviewOnceReady = true;
    }
  }

  let hideWebviewWidget = () => {
    if (typeof $store !== 'undefined' &&  $store !== undefined && $store.state !== undefined) {
      $store.state.showWebviewWidget = false;
    }
  }

  // watch for a specific class change
  let classWatcher = new ClassWatcher(body, 'sm-engaged',
    () => {
      clearTimeout(engagementStartedTimerHolder)
      showWebviewWidget()
    },
    hideWebviewWidget)

  let presentWebview = () => {
    //prevent sm-visitor-app chat UI to be displayed during engagement
    document.getElementsByClassName('webview--app')[0].classList.add('present');
    document.getElementsByClassName('theme-app')[0].classList.add('present');
  }

  let clearWebviewConversation = () => {
    document.getElementById('kai-core-components').replaceChildren()
    document.getElementById('kai-qr-bottom-bar').replaceChildren()
    Kai.API.clearShortcutMenu()
    $store.state.kaiSessionId = ''
    $store.state.liveChatStarted = false
    Kai.API.typingIndicator(false)
  }

  let presentSMChat = () => {
    if (document.getElementsByClassName('webview--app').length > 0) {
      document.getElementsByClassName('webview--app')[0].classList.remove('present');
    }
  }

  let findScriptParameter = (parameterName) => {
    let result
    if (scriptSrc) {
      const scriptURL = new URL(scriptSrc)
      const scriptParams = new URLSearchParams(scriptURL.search)
      result = scriptParams.get(parameterName)
    }
    return result
  }

  document.addEventListener("webviewReady", () => {
    if (getWedgeVariableForDomain('enableGlia') === null || (getWedgeVariableForDomain('enableGlia') && getWedgeVariableForDomain('enableGlia').toLowerCase() === 'true')) {
     isWebviewReady = true
     if (document.getElementsByClassName('sm-visitor-app-container').length > 0) {
       document.getElementsByClassName('sm-visitor-app-container')[0].style.cssText='display:initial';
     }
     if (getWedgeVariableForDomain('enableGlia') && getWedgeVariableForDomain('enableGlia').toLowerCase() === 'true') {
       kaiEngineNames = getWedgeVariableForDomain('engineNameForGlia')
     } else {
       kaiEngineNames = findScriptParameter("engine_name")
       kaiEngineNames ??= 'kai'
 
     }
 
     if (showWebviewOnceReady) {
       showWebviewOnceReady = false
       showWebviewWidget();
     }
 
     if (engagementStarted) {
       if (isOperatorKai()) {
         presentWebview()
         showWebviewWidget()
         for (let message of messagesToRenderWhenReady) {
           renderCapiMessage(message)
         }
         messagesToRenderWhenReady = []
 
         document.getElementsByClassName('webview--app')[0].classList.add('sm-chat')
         document.getElementsByClassName('webview--app')[0].classList.add('sm-engaged')
         document.getElementsByClassName('webview--app')[0].classList.add('sm-engaged-right')
 
       } else {
         presentSMChat()
         hideWebviewWidget()
       }
     }
 
     // reduce the message delay timer for a few seconds in case page has just reload and previous message history need to be displayed at once.
     const oldTimer = $store.state.defaultMessageDelayTimer
     $store.state.defaultMessageDelayTimer = 1;
     setTimeout(
       () => {
         $store.state.defaultMessageDelayTimer=oldTimer
       }, 6000)
 
     $store.state.headerBarConfig.overrideCloseButtonClick = () => {
       //TODO: once WV supports popup template, add confirmation message before ending engagement.
       engagementChat.end()
     }

     $store.state.headerBarConfig.overrideMinimizeButtonClick = () => {
      document.querySelector('.webview_widget_launcher').style.visibility='initial';
      $store.state.showWebviewWidget = false
      // watch $store for showWebviewWidget to be true to hide again the webview widget icon
      const unwatch = $store.watch((state) => state.showWebviewWidget, (newVal, oldVal) => {
        if (newVal === true) {
          document.querySelector('.webview_widget_launcher').style.visibility='hidden';
          unwatch()
        }
      })
    }
 
     Kai.API.sendUserMessage = (msg, callback, optionalDisplayText, optionalInputType) => {
       $store.dispatch('actionSendMessage', true)
       let displayText;
       if (optionalDisplayText && optionalDisplayText.trim() !== '') {
         displayText = optionalDisplayText
       } else {
         displayText = msg
       }
       $store.dispatch('actionInputMessage', displayText)
       $store.state.liveChatStarted = true
       Kai.API.typingIndicator(true)
       $store.state.liveChatStarted = false
       kserver.CoreAPI.sendMessage(msg, optionalInputType, [{
         "key": "displayText",
         "value": displayText
       }])
       Kai.API.removeQuickReplies();
       Kai.API.removeNbestBottom()
       Kai.API.closeShortcutPanel()
     }
 
     kserver.CoreAPI.sendMessage = (message, optionalInputType, metaFields, callback) => {
       let requestJson = {}
       let displayText 
       if (metaFields) {
         displayText = metaFields.filter(({key, value}) => {if (key === 'displayText') return value}).map(({value}) => value)[0];
       }
       if (optionalInputType === 'SELECT') {
         requestJson.type = 'SELECT'
         if (!message) {
           requestJson.payload = {}
         } else if (Array.isArray(message)) {
           requestJson.payload = {
             values: message
           }
         } else {
           requestJson.payload = {
             value: message
           }
         }
       } else if (optionalInputType === 'DATE') {
         requestJson.type = 'DATE'
         requestJson.payload = {
           date: message
         }
       } else if (optionalInputType === 'POSTBACK') {
         requestJson.type = 'POSTBACK'
         requestJson.payload = {
           state: message
         }
       } else if (optionalInputType === 'VOICE') {
         // TODO: set to type VOICE once it is fully supported by Platform.
         requestJson.type = 'TEXT'
         requestJson.payload = {
           text: message
         }
       } else {
         requestJson.type = 'TEXT'
         requestJson.payload = {
           text: message
         }
       }
 
       if (displayText === undefined) {
         displayText = message
       }
 
       requestJson.context = kserver.CoreAPI.getContext()
 
       engagementChat.chat.sendMessage(displayText, {
         attachment: {
           type: 'single_choice_response',
           selected_option: JSON.stringify(requestJson)
         }
       });
       callback && callback()
     }
   }
  })

  document.addEventListener("webviewFunctionForNative:", () => {
    if (params && params.type.toLowerCase() === 'live_chat') {
      // send live_chat deeplink back as a postback message
      Kai.API.postBackMessage(params)
    }
  })

  // Needed for Q2 integration
  const getWedgeVariableForDomain = (variableName) => {
    const domainVariable = `${variableName}_${window.location.hostname}`
    if (window.__Kasisto_webview !== undefined) {
      let overrides = window.__Kasisto_webview.overrides
      if (overrides !== undefined) {
          overrides = overrides[window.location.hostname]
      }
      if (overrides !== undefined) {
          const override_val = overrides[variableName]
          if (override_val !== undefined) {
              return override_val
          }
      }
      if (window.__Kasisto_webview[domainVariable] !== undefined) {
        return window.__Kasisto_webview[domainVariable]
      } else {
        return window.__Kasisto_webview[variableName]
      }
    } else {
      return null
    }
  }

  let renderCapiMessage = (message) => {
    if (message.metadata && message.metadata.capi_response &&
      messagesHistory.length > 0) {
      // Kai.API.handleResponse(JSON.parse(message.metadata.capi_response))
      setTimeout(() => kserver.CoreAPI.checkForSessionIDAndHandleResponse(JSON.parse(message.metadata.capi_response)), 100)
    } else if ((!message.metadata || message.metadata === undefined) && message.sender.toLowerCase() !== 'visitor' 
      && (!message.attachment || message.attachment === undefined) && message.content && message.content.length > 0) {
      // if capi_response is not provided in the metadata try to just render the message content as a plain text
      // This is particularly useful to display Transfer notification message send by the adapter and that are passed as plain message.content by Glia
      setTimeout(() => kserver.CoreAPI.checkForSessionIDAndHandleResponse({"status":{"code":"200"},"message_contents":[{"type":"TEXT","payload":{"text":message.content}}]}), 100)
    }
  }

  let isOperatorKai = () => {
    let isKai = false
    if (kaiEngineNames !== undefined && kaiEngineNames.length > 0) {
      const engineNamesArray = kaiEngineNames.split(',').map((name) => name.trim());
      for (let names of engineNamesArray) {
        if (names && engagementChat && engagementChat.operator.name.toLowerCase() === names.toLowerCase()) {
          isKai = true
          break
        }
      }
    }
    return isKai
  }

  let initializeGlia = () => {
    if (typeof sm !== 'undefined') {
      setupGlia();
    } else {
      setTimeout(() => initializeGlia(), 1000)
    }
  }

  let setupGlia = () => {
    if (!gliaAPI) {
      sm.getApi({
        version: 'v1'
      }).then(function (api) {
        if (!gliaAPI) {
          gliaAPI = api
          onGliaAPICallback(api)
        }
      });
      setTimeout(() => {
        setupGlia()
      }, 1000)
    }
  }

  let onGliaAPICallback = (api) => {
    if (document.getElementsByClassName('sm-visitor-app').length > 0 && !isWebviewReady) {
      document.getElementsByClassName('sm-visitor-app-container')[0].style.cssText='display:none !important';
    }
    let previousState = ''
    let isTransferred = false

    const sendSelectedChoice = ({
      selectedText,
      selectedValue
    }) => {
      engagementChat.chat.sendMessage(selectedText, {
        attachment: {
          type: 'single_choice_response',
          selected_option: selectedValue
        }
      });
    };

    const buildCardQuestionElm = (question) => {
      const cardQuestion = document.createElement('div');
      cardQuestion.classList.add('sm-choice-card-question');
      cardQuestion.innerHTML = question;

      return cardQuestion;
    };

    const buildCardImageElement = (imageUrl) => {
      const cardImage = document.createElement('div');
      cardImage.classList.add('sm-choice-card-image-container');
      cardImage.innerHTML = `<img src="${imageUrl}" />`;

      return cardImage;
    };

    const buildCardButtonElement = (url, type) => {
      const option = document.createElement('div');
      option.classList.add('sm-choice-card-options');
      option.innerHTML = '<a target="_blank" href="' + url + '">' + type + '</a>';
      option.addEventListener('click', function () {
        sendSelectedChoice({
          selectedText: type,
          selectedValue: type
        });
      });

      return option;
    };

    let onEnd = (data) => {
      engagementStarted = false
      hideWebviewWidget()
      setTimeout(() => {
          presentSMChat();
          clearWebviewConversation();
          isTransferred = false
          previousState = ''
          }, 300);
    }

    let onStateChange = (data) => {
      if (data.status === 'transferring') {
        presentSMChat()
        hideWebviewWidget()
      } else if(!isOperatorKai()) {
        presentSMChat()
        hideWebviewWidget()
        if (previousState === 'transferring') {
          isTransferred = true
        }
      } else {
        presentWebview();
        showWebviewWidget()
        if (isTransferred) {
          isTransferred = false
        }
      }
      previousState = data.status
    }

    api.setEngagementReestablishHandler((engagement) => {
      engagementChat = engagement;
      engagementStarted = true
      if (typeof $store !== 'undefined' &&  $store !== undefined && $store.state !== undefined) {
        presentWebview()
        showWebviewWidget()
      }
    })

    api.addEventListener(api.EVENTS.ENGAGEMENT_START, engagement => {
      document.getElementsByClassName('sm-visitor-app-container')[0].style.cssText='display:initial';
      engagementChat = engagement;
      engagementStarted = true
      if (typeof $store !== 'undefined' &&  $store !== undefined && $store.state !== undefined) {
        if (isOperatorKai()) {
          presentWebview()
          engagementStartedTimerHolder = setTimeout(() => {
            // In theory Glia adds to the page <body> the class 'sm-engaged' a few seconds after this ENGAGEMENT_START event is received.
            // And the 'classWatch' is used to observe when 'sm-engaged' is added and to know when it is OK to display the Webview.
            // In practice sometimes when doing a page refresh, this class is not properly added to the DOM despite the ENGAGEMENT_START event being triggered.
            // hence we add the sm-engaged class manually here.
            document.getElementsByClassName('webview--app')[0].classList.add('sm-engaged')
          }, 3000)
        }
      }

      engagementChat.addEventListener(engagementChat.EVENTS.END, onEnd)
      engagementChat.addEventListener(engagementChat.EVENTS.STATE_CHANGE, onStateChange)
    });

    api.visitorApp.setChatMessageRenderer(function (message) {
      if (!messagesHistory.includes(message.id)) {
        if (typeof $store !== 'undefined' &&  $store !== undefined && $store.state !== undefined) {
          renderCapiMessage(message)
          messagesHistory.push(message.id)
        } else {
          messagesToRenderWhenReady.push(message)
          console.log('api.visitorApp.setChatMessageRenderer - webview not ready !!!')
        }
      }
      if (message.metadata && message.metadata.url) {
        const cardContainer = document.createElement('div');
        cardContainer.classList.add('sm-choice-card-container');
        cardContainer.appendChild(buildCardQuestionElm(message.content));
        if (message.metadata.image_url) {
          cardContainer.appendChild(
            buildCardImageElement(message.metadata.image_url)
          );
        }

        cardContainer.appendChild(
          buildCardButtonElement(message.metadata.url, message.metadata.type)
        );

        return cardContainer;
      }
      return false;
    });
  }

  initializeGlia();